module.exports = __webpack_public_path__ + "static/media/A_goodnest_ux.6f270768.png";